import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import axios from "axios";
import config from "../config/config.json";
import "../styles/FaqSection.css";
import { useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useLocation } from "react-router-dom";
import TransportationTable1 from "../Transportation/TransportationTable1";
import TransportationTable2 from "../Transportation/TransportationTable2";
import TransportationTable3 from "../Transportation/TransportationTable3";
import TransportationTable4 from "../Transportation/TransportationTable4";
import TransportationTable5 from "../Transportation/TransportationTable5";
import TransportationTable6 from "../Transportation/TransportationTable6";
import TransportationTable7 from "../Transportation/TransportationTable7";
import TransportationTable8 from "../Transportation/TransportationTable8";
import TransportationTable9 from "../Transportation/TransportationTable9";
import TransportationTable10 from "../Transportation/TransportationTable10";
import TransportationTable11 from "../Transportation/TransportationTable11";
import TransportationTable12 from "../Transportation/TransportationTable12";
import TransportationTable13 from "../Transportation/TransportationTable13";
import TransportationTable14 from "../Transportation/TransportationTable14";
import TransportationTable16 from "../Transportation/TransportationTable16";
import TransportationTable17 from "../Transportation/TransportationTable17";
import TransportationTable18 from "../Transportation/TransportationTable18";
import TransportationTable15 from "../Transportation/TransportationTable15";
import TransportationTable19 from "../Transportation/TransportationTable19";
import TransportationTable20 from "../Transportation/TransportationTable20";
import TransportationTable21 from "../Transportation/TransportationTable21";
import TransportationTable22 from "../Transportation/TransportationTable22";
import TransportationTable23 from "../Transportation/TransportationTable23";
import TransportationTable24 from "../Transportation/TransportationTable24";

export const TransportationAndWarehousingFaqSection = ({ searchTerm }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Employment-Trend");

  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [data_tw_q1, set_data_tw_q1] = useState([]);
  const [data_tw_q2, set_data_tw_q2] = useState([]);
  const [data_tw_q3, set_data_tw_q3] = useState([]);
  const [data_tw_q4, set_data_tw_q4] = useState([]);
  const [data_tw_q5, set_data_tw_q5] = useState([]);
  const [data_tw_q6, set_data_tw_q6] = useState([]);
  const [data_tw_q7, set_data_tw_q7] = useState([]);
  const [data_tw_q8, set_data_tw_q8] = useState([]);
  const [data_tw_q9, set_data_tw_q9] = useState([]);
  const [data_tw_q10, set_data_tw_q10] = useState([]);
  const [data_tw_q11, set_data_tw_q11] = useState([]);
  const [data_tw_q12, set_data_tw_q12] = useState([]);
  const [data_tw_q13, set_data_tw_q13] = useState([]);
  const [data_tw_q14, set_data_tw_q14] = useState([]);
  const [data_tw_q15, set_data_tw_q15] = useState([]);
  const [data_tw_q16, set_data_tw_q16] = useState([]);
  const [data_tw_q17, set_data_tw_q17] = useState([]);
  const [data_tw_q18, set_data_tw_q18] = useState([]);
  const [data_tw_q19, set_data_tw_q19] = useState([]);
  const [data_tw_q20, set_data_tw_q20] = useState([]);
  const [data_tw_q21, set_data_tw_q21] = useState([]);
  const [data_tw_q22, set_data_tw_q22] = useState([]);
  const [data_tw_q23, set_data_tw_q23] = useState([]);
  const [data_tw_q24, set_data_tw_q24] = useState([]);

  useEffect(() => {
    axios
      .get(config.APP_URL + "/tw/tw_verticals")
      .then((response) => {
        if (response.data.success) {
          set_data_tw_q1(
            response.data.data.data_get_total_employment_for_tw_q1
          );
          set_data_tw_q2(
            response.data.data.data_get_employment_trends_of_female_tw_q2
          );
          set_data_tw_q3(
            response.data.data.data_get_male_employment_trend_tw_q3
          );
          set_data_tw_q4(response.data.data.data_get_employment_for_gft_tw_q4);
          set_data_tw_q5(
            response.data.data
              .data_get_employment_for_warehousing_and_storage_tw_q5
          );
          set_data_tw_q6(
            response.data.data.data_get_employment_trend_for_salt_lake_ut_tw_q6
          );
          set_data_tw_q7(response.data.data.data_age_analysis_tw_q7);
          set_data_tw_q8(response.data.data.data_age_analysis_tw_q8);
          set_data_tw_q9(response.data.data.data_age_analysis_tw_q9);
          set_data_tw_q10(response.data.data.data_age_analysis_tw_q10);
          set_data_tw_q11(response.data.data.data_age_analysis_tw_q11);
          set_data_tw_q12(response.data.data.data_age_analysis_tw_q12);
          set_data_tw_q13(response.data.data.data_education_analysis_tw_q13);
          set_data_tw_q14(response.data.data.data_education_analysis_tw_q14);
          set_data_tw_q15(response.data.data.data_education_analysis_tw_q15);
          set_data_tw_q16(response.data.data.data_education_analysis_tw_q16);
          set_data_tw_q17(response.data.data.data_education_analysis_tw_q17);
          set_data_tw_q18(response.data.data.data_education_analysis_tw_q18);
          set_data_tw_q19(response.data.data.data_race_analysis_tw_q19);
          set_data_tw_q20(response.data.data.data_race_analysis_tw_q20);
          set_data_tw_q21(response.data.data.data_race_analysis_tw_q21);
          set_data_tw_q22(response.data.data.data_race_analysis_tw_q22);
          set_data_tw_q23(response.data.data.data_race_analysis_tw_q23);
          set_data_tw_q24(response.data.data.data_race_analysis_tw_q24);
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab");
    const question = searchParams.get("question");

    if (tab) setActiveTab(tab);
    if (question) setExpandedQuestion(decodeURIComponent(question));
  }, [location.search]);

  const handleTabSelect = (tabKey) => {
    setActiveTab(tabKey);
    setExpandedQuestion(null); // Reset expanded question when switching tabs
  };

  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [isOpen7, setIsOpen7] = useState(false);
  const [isOpen8, setIsOpen8] = useState(false);
  const [isOpen9, setIsOpen9] = useState(false);
  const [isOpen10, setIsOpen10] = useState(false);
  const [isOpen11, setIsOpen11] = useState(false);
  const [isOpen12, setIsOpen12] = useState(false);
  const [isOpen13, setIsOpen13] = useState(false);
  const [isOpen14, setIsOpen14] = useState(false);
  const [isOpen15, setIsOpen15] = useState(false);
  const [isOpen16, setIsOpen16] = useState(false);

  const [isOpen17, setIsOpen17] = useState(false);
  const [isOpen18, setIsOpen18] = useState(false);
  const [isOpen19, setIsOpen19] = useState(false);
  const [isOpen20, setIsOpen20] = useState(false);
  const [isOpen21, setIsOpen21] = useState(false);
  const [isOpen22, setIsOpen22] = useState(false);
  const [isOpen23, setIsOpen23] = useState(false);
  const [isOpen24, setIsOpen24] = useState(false);
  const [isOpen25, setIsOpen25] = useState(false);
  const [isOpen26, setIsOpen26] = useState(false);
  const [isOpen27, setIsOpen27] = useState(false);
  const [isOpen28, setIsOpen28] = useState(false);
  const [isOpen29, setIsOpen29] = useState(false);
  const [isOpen30, setIsOpen30] = useState(false);
  const [isOpen31, setIsOpen31] = useState(false);
  const [isOpen32, setIsOpen32] = useState(false);

  const [currentOpenIndex, setCurrentOpenIndex] = useState(null);

  const isOpenStates = [
    setIsOpen1,
    setIsOpen2,
    setIsOpen3,
    setIsOpen4,
    setIsOpen5,
    setIsOpen6,
    setIsOpen7,
    setIsOpen8,
    setIsOpen9,
    setIsOpen10,
    setIsOpen11,
    setIsOpen12,
    setIsOpen13,
    setIsOpen14,
    setIsOpen15,
    setIsOpen16,
    setIsOpen17,
    setIsOpen18,
    setIsOpen19,
    setIsOpen20,
    setIsOpen21,
    setIsOpen22,
    setIsOpen23,
    setIsOpen24,
    setIsOpen25,
  ];

  const handleSetOpen = (openIndex, currentOpenIndex) => {
    if (openIndex === currentOpenIndex) {
      // If already open, close all
      isOpenStates.forEach((setFn) => setFn(false));
    } else {
      // Close all, then open selected
      isOpenStates.forEach((setFn, i) => {
        setFn(i === openIndex - 1);
      });
    }
  };

  return (
    <div className="w-[85vw] sm:w-[90vw] h-auto p-1 justify-center items-center mx-auto">
      <Tabs
        id="controlled-tab-example"
        className="tabs"
        activeKey={activeTab}
        onSelect={handleTabSelect}
      >
        {/* employment trend */}
        <Tab
          eventKey="Employment-Trend"
          title="Employment Trend"
          id="Employment-Trend"
        >
          <Accordion>
            <Accordion.Item
              eventKey="1. What is the total employment for Transportation and Warehousing industry  for each year from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(1, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 1 ? null : 1);
                setExpandedQuestion(
                  "1. What is the total employment for Transportation and Warehousing industry  for each year from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the total employment for Transportation and
                  Warehousing industry for each year from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 1 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable1 data={data_tw_q1} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="2. What trends are observed in the employment of female workers in the Transportation and Warehousing industry?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(2, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 2 ? null : 2);
                setExpandedQuestion(
                  "2. What trends are observed in the employment of female workers in the Transportation and Warehousing industry?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. What trends are observed in the employment of female
                  workers in the Transportation and Warehousing industry?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 2 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable2 data={data_tw_q3} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="3. What is the quarterly employment trend for 'Male' employees in the Transportation and Warehousing industry?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(3, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 3 ? null : 3);
                setExpandedQuestion(
                  "3. What is the quarterly employment trend for 'Male' employees in the Transportation and Warehousing industry?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What is the quarterly employment trend for 'Male' employees
                  in the Transportation and Warehousing industry?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 3 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable3 data={data_tw_q2} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="4. How does the total employment for 'General Freight Trucking' compare between 'Beaver, UT' and 'Weber, UT' in the year 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(4, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 4 ? null : 4);
                setExpandedQuestion(
                  "4. How does the total employment for 'General Freight Trucking' compare between 'Beaver, UT' and 'Weber, UT' in the year 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. How does the total employment for 'General Freight
                  Trucking' compare between 'Beaver, UT' and 'Weber, UT' in the
                  year 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 4 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable4 data={data_tw_q4} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="5. How has the employment in the 'Warehousing and Storage' industry changed over the years?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(5, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 5 ? null : 5);
                setExpandedQuestion(
                  "5. How has the employment in the 'Warehousing and Storage' industry changed over the years?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. How has the employment in the 'Warehousing and Storage'
                  industry changed over the years?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 5 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <TransportationTable5 data={data_tw_q5} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='6. What is the distribution of employment across different industries in "Salt Lake, UT"?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(6, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 6 ? null : 6);
                setExpandedQuestion(
                  '6. What is the distribution of employment across different industries in "Salt Lake, UT"?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. What is the distribution of employment across different
                  industries in "Salt Lake, UT"?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 6 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <TransportationTable6 data={data_tw_q6} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Age Analysis */}
        <Tab eventKey="Age-Analysis" title="Age Analysis" id="Age-Analysis">
          <Accordion>
            <Accordion.Item
              eventKey="1. What is the percentage of employment each age group contributes to the total employment in the Transportation and Warehousing industry?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 7 ? null : 7);
                setExpandedQuestion(
                  "1. What is the percentage of employment each age group contributes to the total employment in the Transportation and Warehousing industry?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the percentage of employment each age group
                  contributes to the total employment in the Transportation and
                  Warehousing industry?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 7 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable7 data={data_tw_q7} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="2. For the '14-18' age group, which industry has the highest employment in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 8 ? null : 8);
                setExpandedQuestion(
                  "2. For the '14-18' age group, which industry has the highest employment in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. For the '14-18' age group, which industry has the highest
                  employment in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 8 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable8 data={data_tw_q8} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="3. How does the employment of the '65-99' age group compare between 'Male' and 'Female' in the 'Transportation and Warehousing' industry?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 9 ? null : 9);
                setExpandedQuestion(
                  "3. How does the employment of the '65-99' age group compare between 'Male' and 'Female' in the 'Transportation and Warehousing' industry?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. How does the employment of the '65-99' age group compare
                  between 'Male' and 'Female' in the 'Transportation and
                  Warehousing' industry?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 9 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable9 data={data_tw_q9} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="4. What is the total employment for the '25-34' age group over all years from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 10 ? null : 10);
                setExpandedQuestion(
                  "4. What is the total employment for the '25-34' age group over all years from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. What is the total employment for the '25-34' age group over
                  all years from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 10 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable10 data={data_tw_q10} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="5. How does the employment of the '35-44' age group compare between Male and Female employees across all industries under 'Transportation and Warehousing'?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 11 ? null : 11);
                setExpandedQuestion(
                  "5. How does the employment of the '35-44' age group compare between Male and Female employees across all industries under 'Transportation and Warehousing'?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. How does the employment of the '35-44' age group compare
                  between Male and Female employees across all industries under
                  'Transportation and Warehousing'?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 11 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable11 data={data_tw_q11} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="6. Which age group had the highest employment in the 'Warehousing and Storage' industry in the fourth quarter of 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 12 ? null : 12);
                setExpandedQuestion(
                  "6. Which age group had the highest employment in the 'Warehousing and Storage' industry in the fourth quarter of 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. Which age group had the highest employment in the
                  'Warehousing and Storage' industry in the fourth quarter of
                  2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 12 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable12 data={data_tw_q12} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Education Analysis */}
        <Tab
          eventKey="Education-Analysis"
          title="Education Analysis"
          id="Education-Analysis"
        >
          <Accordion>
            <Accordion.Item
              eventKey="1. What is the total employment across all education levels for each year from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 13 ? null : 13);
                setExpandedQuestion(
                  "1. What is the total employment across all education levels for each year from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the total employment across all education levels
                  for each year from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 13 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable13 data={data_tw_q13} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='2. How does the employment of individuals with a "Bachelor" degree compare between Male and Female workers in "Transportation and Warehousing" for a specific year?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 14 ? null : 14);
                setExpandedQuestion(
                  '2. How does the employment of individuals with a "Bachelor" degree compare between Male and Female workers in "Transportation and Warehousing" for a specific year?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. How does the employment of individuals with a "Bachelor"
                  degree compare between Male and Female workers in
                  "Transportation and Warehousing" for a specific year?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 14 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable14 data={data_tw_q14} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='3. What is the total number of female workers with "Less than high school" education in all industries and all years?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 15 ? null : 15);
                setExpandedQuestion(
                  '3. What is the total number of female workers with "Less than high school" education in all industries and all years?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What is the total number of female workers with "Less than
                  high school" education in all industries and all years?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 15 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable15 data={data_tw_q15} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='4. How does the Male to Female ratio of employees with a "Bachelor" degree vary across Transportation and Warehousing industries?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 16 ? null : 16);
                setExpandedQuestion(
                  '4. How does the Male to Female ratio of employees with a "Bachelor" degree vary across Transportation and Warehousing industries?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. How does the Male to Female ratio of employees with a
                  "Bachelor" degree vary across Transportation and Warehousing
                  industries?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 16 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable16 data={data_tw_q16} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='5. How has the employment of people with "High school or equivalent, no college" changed over time in all of Utah?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 17 ? null : 17);
                setExpandedQuestion(
                  '5. How has the employment of people with "High school or equivalent, no college" changed over time in all of Utah?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. How has the employment of people with "High school or
                  equivalent, no college" changed over time in all of Utah?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 17 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable17 data={data_tw_q17} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='6. What is the distribution of education levels for male and female employees in "Transportation and Warehousing  Industry" in 2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 18 ? null : 18);
                setExpandedQuestion(
                  '6. What is the distribution of education levels for male and female employees in "Transportation and Warehousing  Industry" in 2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. What is the distribution of education levels for male and
                  female employees in "Transportation and Warehousing Industry"
                  in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 18 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable18 data={data_tw_q18} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Race Analysis */}
        <Tab eventKey="Race-Analysis" title="Race Analysis" id="Race-Analysis">
          <Accordion>
            <Accordion.Item
              eventKey="1. How has the total employment in the Transportation and Warehousing industry trended over time by race?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 19 ? null : 19);
                setExpandedQuestion(
                  "1. How has the total employment in the Transportation and Warehousing industry trended over time by race?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. How has the total employment in the Transportation and
                  Warehousing industry trended over time by race?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 19 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable19 data={data_tw_q19} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='2. What percentage of the total employment in 2024 was from the "Black or African American Alone" race?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 20 ? null : 20);
                setExpandedQuestion(
                  '2. What percentage of the total employment in 2024 was from the "Black or African American Alone" race?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. What percentage of the total employment in 2024 was from
                  the "Black or African American Alone" race?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 20 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable20 data={data_tw_q20} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='3. What is the total employment for "White Alone" employees compared to all other races combined for Q4-2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 21 ? null : 21);
                setExpandedQuestion(
                  '3. What is the total employment for "White Alone" employees compared to all other races combined for Q4-2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What is the total employment for "White Alone" employees
                  compared to all other races combined for Q4-2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 21 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable21 data={data_tw_q21} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='4. What is the percentage of "Black or African American Alone" employees in the "Transportation and Warehousing" industry for Salt Lake county from 2018 to 2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 22 ? null : 22);
                setExpandedQuestion(
                  '4. What is the percentage of "Black or African American Alone" employees in the "Transportation and Warehousing" industry for Salt Lake county from 2018 to 2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. What is the percentage of "Black or African American Alone"
                  employees in the "Transportation and Warehousing" industry for
                  Salt Lake county from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 22 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable22 data={data_tw_q22} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='5. What is the employment breakdown by race for the "Warehousing and Storage" industry in "Salt Lake, UT" for 2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 23 ? null : 23);
                setExpandedQuestion(
                  '5. What is the employment breakdown by race for the "Warehousing and Storage" industry in "Salt Lake, UT" for 2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. What is the employment breakdown by race for the
                  "Warehousing and Storage" industry in "Salt Lake, UT" for
                  2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 23 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TransportationTable23 data={data_tw_q23} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='6. How does the total employment of "Native Hawaiian or Other Pacific Islander Alone" employees vary across years?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 24 ? null : 24);
                setExpandedQuestion(
                  '6. How does the total employment of "Native Hawaiian or Other Pacific Islander Alone" employees vary across years?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. How does the total employment of "Native Hawaiian or Other
                  Pacific Islander Alone" employees vary across years?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 24 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <TransportationTable24 data={data_tw_q24} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>
      </Tabs>
    </div>
  );
};
